import { createContext, useContext } from 'react'

import type { VersionService } from './VersionService'

/**
 * `null` quando não há provider acima. Os hooks toleram esse caso de propósito:
 * `useReloadGuard` é adotado dentro de fluxos (level-play, check-in) que também
 * são montados em teste e em storybook, e uma guarda de reload não pode ser
 * motivo de crash numa árvore sem o serviço.
 */
export const VersionContext = createContext<VersionService | null>(null)

export const useVersionService = () => useContext(VersionContext)
